import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { ApiService, CacheService, PageService } from '@gallaghercp/core-frontend';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BsDropdownConfig, BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { FormControl } from '@angular/forms';
import { ClientService } from '../../services/client.service';

@Component({
    standalone: false,
    selector: 'core-page-header',
    templateUrl: './page-header.component.html',
    providers: [{ provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: false } }],
})
export class PageHeaderComponent implements OnInit {
    @ViewChild(BsDropdownDirective) dropdown!: { hide: () => void };
    page: any;
    activeMenuTab = new FormControl(0);
    fragment?: string;
    resizeTimeout: any;
    loadedPage: any;
    destinationPage: any;

    // Menu Variables
    pages$!: Observable<any>;
    content$!: Observable<any>;
    isCollapsed = true;
    childNav = false;
    isBenefitSubpage?: boolean;
    isCloudAcademy?: boolean;
    isLandingPageHeader = false;

    constructor(
        protected pages: PageService,
        private router: Router,
        private route: ActivatedRoute,
        private api: ApiService,
        private cache: CacheService,
        public client: ClientService,
    ) {}

    // This handles changing pages. It's shared across all screen sizes.
    // 1: It will automatically close the dropdown menu on Desktop
    // 2: It will also remove the mobile styling if user navigates page on mobile
    // 3: If the menu is open on mobile it will close it
    // 6: Will then navigate to correct page
    navigateToPage(page: string) {
        if (this.dropdown) {
            this.dropdown.hide();
        }
        document.body.style.overflowY = 'revert';
        if (!this.isCollapsed) {
            this.isCollapsed = true;
        }
        if (page.indexOf('#') > -1) {
            // Contains HASH!
            const urlArray = page.split('#');
            this.router.navigate([urlArray[0]], { fragment: urlArray[1] });
            this.closeChildNav();
        } else if (page.indexOf('https://') > -1 || page.indexOf('http://') > -1) {
            window.location.href = page;
        } else {
            // No Hash, proceed as usual
            this.router.navigate(['/' + page]);
            this.closeChildNav();
        }
    }

    ngOnInit(): void {
        this.isCloudAcademy = false; // TO DO: REMOVE
        if (this.api.getServiceZone() === '2') {
            this.isCloudAcademy = true;
        } else {
            this.content$ = this.cache.getListThroughCache('page-categories');
            this.pages$ = this.pages.getAll();
            this.pages.currentPage$!.subscribe(page => {
                if (page) {
                    this.evaluateParentPage(page);
                }
            });
            this.checkPage();
            document.addEventListener('click', ({ target }) => {
                if (document.getElementById('paloNavbar')!.contains(target as HTMLElement)) {
                    // console.log('Inside navbar, do nothing - just chill');
                } else {
                    this.dropdown.hide();
                }
            });
        }
    }

    trackByFn(idx: number) {
        return idx;
    }

    menuStateCheck(menuState: any) {
        // Close any child navs that are open (Foundation etc)
        this.closeChildNav();
        // Close the Benefits dropdown if it was open
        this.dropdown.hide();
        // Check if the menu is open, and if so, stop body from scrolling
        if (menuState) {
            document.body.style.overflowY = 'revert';
        } else {
            document.body.style.overflowY = 'hidden';
        }
    }

    toggleChildNav(cat: { name: string }) {
        const catNameLower = cat.name.toLowerCase();
        const catNameSafe = catNameLower.replace(/[\W_]+/g, '');
        const element = document.getElementById('benefits-submenu-' + catNameSafe);
        if (element) {
            element.classList.add('benefits-submenu--open');
        }
    }

    closeChildNav() {
        const allChildNavs = document.getElementsByClassName('benefits-submenu');
        for (const nav of Array.from(allChildNavs)) {
            nav.classList.remove('benefits-submenu--open');
        }
    }

    evaluateParentPage(page: any) {
        if (document.getElementsByClassName('nav-link').length > 0) {
            // Remove all active classes
            const allLinks = document.getElementsByClassName('nav-link');
            for (const link of Array.from(allLinks)) {
                link.classList.remove('active');
            }

            // Does page have a parent?
            if (page.parentId !== null) {
                // Has parent - get parent page details
                this.pages.getPage(page.parentId).subscribe((parentPage: { url: string }) => {
                    // Once parentPage is received....
                    if (parentPage) {
                        // Set ParentPage active for header
                        // Special 'Benefits' workaround
                        if (parentPage.url === 'benefits') {
                            const element = document.getElementById('navbarDropdown');
                            if (element) {
                                element.classList.add('active');
                            }
                        } else {
                            const element = document.getElementById(parentPage.url.toLowerCase());
                            if (element) {
                                element.classList.add('active');
                            }
                        }
                    }
                });
            } else {
                // No Parent - check URL and make it active
                const element = document.getElementById(page.url.toLowerCase());
                if (element) {
                    element.classList.add('active');
                }
            }
        } else {
            setTimeout(() => {
                this.evaluateParentPage(page);
            }, 300);
        }
    }

    evaluateLink(page: any) {
        if (document.getElementsByClassName('nav-link').length > 0) {
            // Remove all active classes
            const allLinks = document.getElementsByClassName('nav-link');
            for (const link of Array.from(allLinks)) {
                link.classList.remove('active');
            }

            // Does page have a parent?
            if (page.parentId !== null) {
                // Has parent - get parent page details
                this.pages.getPage(page.parentId).subscribe((parentPage: { url: string }) => {
                    // Once parentPage is received....
                    if (parentPage) {
                        // Set ParentPage active for header
                        // Special 'Benefits' workaround
                        if (parentPage.url === 'benefits') {
                            const element = document.getElementById('navbarDropdown');
                            if (element) {
                                element.classList.add('active');
                            }
                        } else {
                            const element = document.getElementById(parentPage.url.toLowerCase());
                            if (element) {
                                element.classList.add('active');
                            }
                        }
                    }
                });
            } else {
                // No Parent - check URL and make it active
                const element = document.getElementById(page.url.toLowerCase());
                if (element) {
                    element.classList.add('active');
                }
            }
        } else {
            setTimeout(() => {
                this.evaluateParentPage(page);
            }, 300);
        }
    }

    mouseEnter(item: { name: any }, event: any) {
        let element: any;
        switch (item.name) {
            case 'Foundational':
                element = document.getElementById('nav-menu-helper__foundational');
                element.classList.add('active');
                break;
            case 'Supplemental':
                element = document.getElementById('nav-menu-helper__supplemental');
                element.classList.add('active');
                break;
            case 'Flexible/Adhoc':
                element = document.getElementById('nav-menu-helper__flexible');
                element.classList.add('active');
                break;
            default:
                break;
        }
    }

    mouseLeave() {
        const allChildNavs = document.getElementsByClassName('nav-menu-helper');
        for (const nav of Array.from(allChildNavs)) {
            nav.classList.remove('active');
        }
    }

    checkPage() {
        this.loadedPage = this.pages.getCurrentPage();
        if (this.loadedPage) {
            this.isLandingPageHeader = this.loadedPage.meta.isLandingPage;
        } else {
            setTimeout(() => {
                this.checkPage();
            }, 250);
        }
    }

    @HostListener('window:resize') onResize() {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout(
            (() => {
                if (window.innerWidth >= 992 && !this.isCollapsed) {
                    this.isCollapsed = true;
                }
            }).bind(this),
            200,
        );
    }
}
